<template>
  <f7-page name="cmde_ligne">
    <f7-navbar title="MOBI-STOCKS" subtitle="Liste article inventorié" >
      <f7-nav-right>
        <f7-link icon-ios="f7:close" icon-aurora="f7:close" icon-md="material:close" @click="openAnnulation"></f7-link>
      </f7-nav-right>  
    </f7-navbar>
    <f7-block>&nbsp;{{site_name}}</f7-block> 

    <f7-fab position="right-top" slot="fixed" @click="openRecherche">
      <f7-icon ios="f7:add" aurora="f7:add" md="material:add"></f7-icon>
    </f7-fab>

    <f7-fab position="center-bottom" slot="fixed" color="green" @click="openTerminer">
      <f7-icon ios="f7:check" aurora="f7:check" md="material:check"></f7-icon>
    </f7-fab>
  
    <f7-list>
      <f7-list-item
        v-for="(link, index) in $f7.data.tableLigne" :key="index"
        :link="`/invt_enter/${index}/ope/upd/`" no-chevron>   
        <f7-link color="red" icon-f7="trash"  @click.stop="openSupprimer( index )" ></f7-link>
        <div slot="title" style="white-space: normal; font-size:14px">{{link.ref}} : <strong>{{link.qte}}</strong> x <strong>{{link.cdtlbl}}</strong> - {{link.postelbl}}<br>{{link.des}}</div>
      </f7-list-item>
    </f7-list>
  </f7-page>
</template>

<script>
  import { InventoryService } from "../service/Inventory_service";

  export default {
    data() {
      debugger;
      this.$f7.data.Invt_num_type = localStorage.getItem("Invt_num_type");
      this.$f7.data.dflt_session = localStorage.getItem("dflt_session");

      this.$f7.data.dflt_site = localStorage.getItem("dflt_site");
      this.$f7.data.dflt_site_name = localStorage.getItem("dflt_site_name");
      this.$f7.data.dflt_poste = localStorage.getItem("dflt_poste");

      this.$f7.data.tableLigne = JSON.parse(localStorage.getItem('tableLigne'));
      this.$f7.data.newInvt =  localStorage.getItem("newInvt");
      this.$f7.data.currentInvt = localStorage.getItem("currentInvt");
      this.$f7.data.ifInvt =  localStorage.getItem("ifInvt");

      return {
        site_name: this.$f7.data.dflt_site_name,
        connexion: null,     // centraliser la connexion !!!
        numcompte: "",
        numoperateur:""
       };
    },  
    mounted () {
      this.connexion = new InventoryService();
      this.numcompte =  localStorage.getItem("glb_numcompte");
      this.numoperateur =  localStorage.getItem("glb_login");
    },
    methods: {

      openRecherche (){
        const app = this.$f7;
        app.views.main.router.navigate( '/article_liste/');

      },

      openAnnulation (){
        const app = this.$f7;
        if ( app.data.tableLigne.length > 0 ){
          app.dialog.confirm('Confirmez-vous l\'annulation de toutes vos modifications ?', () => {
            app.views.main.router.navigate( '/invt_liste/');
          });
        }
        else{
           app.views.main.router.navigate( '/invt_liste/');
        }
      },

      openTerminer (){
        const app = this.$f7;
        if ( app.data.tableLigne.length > 0 ){
          app.dialog.confirm('Confirmez-vous la validation de votre saisie ?', () => {
            //  faire sauvegarde ici
            if ( app.data.newInvt == true || app.data.newInvt == "true"){
              this.openSaveInventory().then((value) =>  {
                app.views.main.router.navigate( '/invt_liste/');
              }, (err) =>  {
                app.dialog.alert('Erreur: Enregistrement non effectué !',  () => { app.views.main.router.navigate( '/invt_liste/'); });                
              });
            }
            else {
              this.openUpdateInventory().then((value) =>  {
                app.views.main.router.navigate( '/invt_liste/');
              }, (err) =>  {
                app.dialog.alert('Erreur: Enregistrement non effectué !',  () => { app.views.main.router.navigate( '/invt_liste/'); });                
              });
            }
          });
        }
        else
        {
          app.dialog.alert('Votre inventaire est vide !');
        }
      },

      openSupprimer( indexToDelete ) {
         debugger;
          var app = this.$f7;
          app.dialog.confirm('Confirmez-vous la suppression de cette ligne ? ',  () => {
            app.data.tableLigne.splice(indexToDelete, 1);

            // Synchro Update LocalStorage
            localStorage.setItem('tableLigne', JSON.stringify(app.data.tableLigne));
          });
      },

      openSaveInventory: async function (){
        debugger;
        const app = this.$f7;
        var tableLigne = app.data.tableLigne;
        const d = new Date();
        const ndate = ("0" + d.getDate()).slice(-2) + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + d.getFullYear();
        const ntime = ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
        var timestamp= d.getFullYear()+d.getMonth()+d.getDate()+d.getHours()+d.getMinutes()+d.getSeconds() ;
        
        // retrouver le libelle du site
        var sitelbl_ = this.$f7.data.dflt_site_name;
        var site_ = this.$f7.data.dflt_site;
        var thetype = this.$f7.data.Invt_num_type;
        var thesession = this.$f7.data.dflt_session;

        // comment enregistrer le site ! qui vient des lignes ?
        const newInventory = {
          num_invt: "",
          code_client: this.numcompte,
          code_operateur : this.numoperateur,
          session: thesession,
          num_type: thetype,
          site: site_,
          name_site: sitelbl_,
          datecreat: ndate,
          timecreat: ntime,
          lignes: tableLigne,
          exporter: "N"
        };
        debugger;
        var result = await this.connexion.addInventory( newInventory);

        //results will contains no of rows added.
        console.log("Result: " + JSON.stringify(result));
        var count = result.length;
        console.log( "Count :" + count);

        //modif num_invt
        debugger;
        var my_id = result[0].id;
        var new_num_invt =  "INV" + ("0000" + my_id).slice(-4) + "_" + timestamp;

        result[0].num_invt = new_num_invt;
        var resultupdt = await this.connexion.updateInventoryById( my_id , result[0]);
      },


     openUpdateInventory: async function (){
        debugger;
        const app = this.$f7;
        var tableLigne = app.data.tableLigne;
        const d = new Date();
        const ndate = ("0" + d.getDate()).slice(-2) + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + d.getFullYear();
        const ntime = ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
        var my_id = parseInt ( app.data.currentInvt);
        var timestamp= d.getFullYear()+d.getMonth()+d.getDate()+d.getHours()+d.getMinutes()+d.getSeconds() ;
        var new_num_invt =  "INV" + ("0000" + my_id).slice(-4) + "_" + timestamp;

        // retrouver le libelle du site
        var sitelbl_ = this.$f7.data.dflt_site_name;
        var site_ = this.$f7.data.dflt_site;
        var thetype = this.$f7.data.Invt_num_type;
        var thesession = this.$f7.data.dflt_session;

        const newInventory = {
          num_invt: new_num_invt,
          code_client: this.numcompte,
          code_operateur : this.numoperateur,
          session: thesession,
          num_type: thetype,
          site: site_,
          name_site: sitelbl_,
          datecreat: ndate,
          timecreat: ntime,
          lignes: tableLigne,
          exporter: "N"
        };
        debugger;
        var result = await this.connexion.updateInventoryById( my_id, newInventory);

        //results will contains no of rows deleted.
        console.log("Result: " + JSON.stringify(result));
        var count = result.length;
        console.log( "Count :" + count);       
      },

    },

  };
</script>